import type { Academy, Club } from '@court-sync/shared';

/**
 * Resolves the club that owns facilities for an academy context.
 * Academy-only orgs use the internal shell club; combined orgs use the real club.
 */
export function resolveFacilityClub(
  academy: Pick<Academy, 'organizationId'> | null | undefined,
  currentClub: Club | null | undefined,
  userClubs: Club[]
): Club | null {
  const organizationId = academy?.organizationId;
  if (!organizationId) {
    return currentClub ?? null;
  }

  if (currentClub?.organizationId === organizationId) {
    return currentClub;
  }

  const orgClubs = userClubs.filter((club) => club.organizationId === organizationId);
  const shellClub = orgClubs.find((club) => club.isInternalShell);
  return shellClub ?? orgClubs[0] ?? null;
}
